import { makeActionCreator } from '../../config/store/utils'
import { getProviderPurchasingMechanisms } from '../../services/providers'

export const GET_PROVIDER_PURCHASING_MECHANISMS = 'GET_PROVIDER_PURCHASING_MECHANISMS'
export const GET_PROVIDER_PURCHASING_MECHANISMS_ERROR = 'GET_PROVIDER_PURCHASING_MECHANISMS_ERROR'
export const GET_PROVIDER_PURCHASING_MECHANISMS_SUCCESS = 'GET_PROVIDER_PURCHASING_MECHANISMS_SUCCESS'
export const onGetProviderPurchasingMechanisms = makeActionCreator(GET_PROVIDER_PURCHASING_MECHANISMS)
export const onGetProviderPurchasingMechanismsError = makeActionCreator(
  GET_PROVIDER_PURCHASING_MECHANISMS_ERROR,
  'payload'
)
export const onGetProviderPurchasingMechanismsSuccess = makeActionCreator(
  GET_PROVIDER_PURCHASING_MECHANISMS_SUCCESS,
  'payload'
)
export const onGetProviderPurchasingMechanismsThunk = payload => async dispatch => {
  dispatch(onGetProviderPurchasingMechanisms())

  try {
    const { data = {} } = await getProviderPurchasingMechanisms({ dni: payload.dni, year: payload.year })
    const enhancedData = data.payload?.map(datum => ({
      amount: datum.amountCLPAnnual,
      amountUSD: datum.amountUSDAnnual,
      name: datum.modalidad,
      orders: datum.numberMonthOCAnnual,
      percentage: datum.percentageAnnual
    }))
    const categories = enhancedData.map(datum => datum.name)
    const csv = [
      ['Mecanismo de compra', 'Nº de órdenes de compra', 'Monto total', 'Monto total (USD)'],
      ...enhancedData.map(datum => [datum.name, datum.orders, datum.amount, datum.amountUSD])
    ]

    return dispatch(onGetProviderPurchasingMechanismsSuccess({ categories, csv, data: enhancedData }))
  } catch (error) {
    return dispatch(onGetProviderPurchasingMechanismsError({ error }))
  }
}
